import { Constant } from '@genial/config';
import { ColorTypes } from '@genial/design-tokens';

import { FilterModalTypes } from '../../../../../../../../components/FilterModal';
import { TableHeadItemRecurse } from '../../../../../../../../components/TableHead';
import { directTreasuryMarketStatusQuery } from '../../../../../../../../store/product/selectors';
import { DynamicCustomFiltersProps } from '../../../../../../../../store/product/types';
import { transformCustomCategories, transformCustomFilters } from '../../../../constants';
import { OperationType } from '../../../../contexts/constants';
import { AssetCaptionType } from '../../../AssetCaptions';
import {
  applicationAmountFilter,
  directTreasuryDaysToRedemptionFilter,
  semiAnnualFilter,
} from '../../../AssetFilters/constants';
import { AssetNoticesNormalized } from '../../../AssetNotices';

import { DirectTreasuryAsset } from '.';

export const directTreasuryTableHead: TableHeadItemRecurse[] = [
  { title: '', flex: 0.5 },
  { title: 'Produto', orderValue: 'titleName', flex: 3 },
  { title: 'Rentabilidade', orderValue: 'purchaseRate', flex: 2 },
  { title: 'Risco', orderValue: 'riskRatingLevel', flex: 2 },
  { title: 'Vencimento', orderValue: 'maturityDate', flex: 2 },
  { title: 'Juros', orderValue: 'feesPayment', flex: 2 },
  { title: 'Quantidade', orderValue: 'minimumStepQuantity', flex: 3 },
  { title: 'A partir de', orderValue: 'minimumApplication', flex: 3 },
  { title: '', flex: 2 },
];

export const directTreasuryConstants = {
  id: 'directTreasury',
  typeGetterId: 'directTreasury',
  title: 'Tesouro Direto',
  operationId: 1,
  operationName: 'Aplicar',
  operationType: 'buy' as OperationType,
  color: 'product.tesouro' as ColorTypes.Option,
  principalComponent: DirectTreasuryAsset,
  tableHead: directTreasuryTableHead,
  hideTableHead: false,
  marketStatusSelector: directTreasuryMarketStatusQuery,
  hasFilters: true,
  mountFilters: (customFilters: DynamicCustomFiltersProps): FilterModalTypes.FilterType[] => {
    return [
      ...transformCustomFilters(customFilters),
      semiAnnualFilter,
      applicationAmountFilter,
      directTreasuryDaysToRedemptionFilter,
    ];
  },
  hasCategories: true,
  categoriesLabel: 'Categorias',
  categoriesField: 'indexer',
  mountCategories: (customFilters: DynamicCustomFiltersProps) =>
    transformCustomCategories(customFilters, 'indexer'),
  captions: [] as AssetCaptionType[],
  groupNotices: false,
  notices: [] as AssetNoticesNormalized[],
  hasRefresher: false,
  unleashFlag: Constant.UnleashDirectTreasuryToggle,
  unleashFlagBatchTicket: Constant.UnleashBasketDirectTreasuryToggle,
  unleashFlagCustomers: Constant.UnleashCustomersDirectTreasuryToggle,
} as const;
